export default __webpack_public_path__ + "static/media/_MG_2303.397804af.jpg";